const HOST_NAME = "https://www.skynet.kamilkazmierczak.usermd.net/api/";

function getMethod(type) {
  return async ({ path, body, queryParams = null }) => {
    const fetchParams = {
      method: type,
      body: JSON.stringify(body),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
    };  

    try {
      const URL = `${HOST_NAME}${path}${queryParams ? `?${new URLSearchParams(queryParams)}` : ''}`
      const response = await fetch(URL, fetchParams);

      return response.json().then(json => {
        if (response.status >= 400) {
          throw new Error("Not implemented exception")
        }
        return json;
      });
    } catch (err) {
      // TODO notification
      throw err;
    } finally {
      // TODO
      // Probably do nothing
    };
  };
};

export default {
  get: getMethod('GET'),
};